/* Nūvo — motion.
   Two effects, both hand-rolled (no library):
     1. Scroll reveal  — brand section content fades + rises as it enters view.
     2. Route progress — a thin gold bar creeps at the top during navigation.

   SAFETY: nothing is hidden by CSS alone. The reveal styles only apply under
   `html.nuvo-motion`, which THIS script adds — so if the script fails, is
   blocked, or the browser has no IntersectionObserver, every element stays
   visible. Content is never parked at opacity:0 waiting on JS that may not run.
   Honours prefers-reduced-motion and the `motion_enable` theme setting. */
(function () {
  'use strict';
  if (window.__nuvoMotionInit) return;
  window.__nuvoMotionInit = true;

  var root = document.documentElement;
  if (root.getAttribute('data-nuvo-motion') === 'off') return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canObserve = 'IntersectionObserver' in window;

  /* ---------- 1. scroll reveal ---------- */
  function reveal() {
    if (reduce || !canObserve) return;
    root.classList.add('nuvo-motion');

    var targets = [];

    function tag(node, index, isCard) {
      node.classList.add('nuvo-rv');
      if (isCard) node.classList.add('nuvo-rv--card');
      var step = isCard ? 110 : 70;          // cards arrive one at a time
      var cap = isCard ? 7 : 4;
      node.style.setProperty('--nuvo-rv-delay', Math.min(index, cap) * step + 'ms');
      targets.push(node);
    }

    document.querySelectorAll('.nuvo .nuvo__wrap').forEach(function (wrap) {
      var kids = Array.prototype.filter.call(wrap.children, function (n) {
        return n.nodeType === 1 && n.offsetHeight > 8;
      });
      kids.forEach(function (n, i) {
        // A grid/flex row of cards animates card-by-card rather than as one block.
        var display = getComputedStyle(n).display;
        var cards = /grid|flex/.test(display)
          ? Array.prototype.filter.call(n.children, function (c) {
              return c.nodeType === 1 && c.offsetHeight > 40;
            })
          : [];
        if (cards.length > 1 && cards.length <= 12) {
          cards.forEach(function (c, j) { tag(c, j, true); });
        } else {
          tag(n, i, false);
        }
      });
    });
    /* The compliance section predates the `.nuvo__wrap` convention, so the sweep
       above never sees it. Tag it explicitly: header, then the navy panel, then
       each commitment one at a time so the list builds rather than appearing. */
    document.querySelectorAll('.research-commitment').forEach(function (sec) {
      var intro = sec.querySelector('.research-commitment__intro');
      if (intro) tag(intro, 0, false);
      var panel = sec.querySelector('.research-commitment__panel');
      if (panel) tag(panel, 1, false);
      Array.prototype.forEach.call(
        sec.querySelectorAll('.research-commitment__item'),
        function (item, j) { tag(item, j, true); }
      );
    });

    if (!targets.length) { root.classList.remove('nuvo-motion'); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, {
      // On phones fire slightly BEFORE the element scrolls in, so it has settled
      // by the time it is actually on screen rather than animating under the thumb.
      rootMargin: window.innerWidth < 750 ? '0px 0px 6% 0px' : '0px 0px -8% 0px',
      threshold: 0.04
    });

    targets.forEach(function (t) {
      // anything already on screen at load shows immediately — no flash of blank
      var r = t.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) t.classList.add('is-in');
      else io.observe(t);
    });
  }

  /* ---------- 2. route progress ---------- */
  var bar;
  function showBar() {
    if (reduce) return;
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'nuvo-route';
      bar.innerHTML = '<span></span>';
      document.body.appendChild(bar);
    }
    bar.classList.remove('is-done');
    // restart the creep animation
    void bar.offsetWidth;
    bar.classList.add('is-on');
  }
  function hideBar() {
    if (!bar) return;
    bar.classList.remove('is-on');
    bar.classList.add('is-done');
  }

  function wireRoute() {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;
      var href = a.getAttribute('href') || '';
      if (!href || href[0] === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return;
      if (a.origin && a.origin !== window.location.origin) return;
      // links that only open UI (search overlay, cart drawer) never navigate
      if (a.hasAttribute('data-nuvo-search-open')) return;
      if (a.id === 'cart-icon-bubble') return;
      showBar();
    });
    // browser restored the page from bfcache -> clear any stale bar
    window.addEventListener('pageshow', hideBar);
    window.addEventListener('pagehide', hideBar);
  }

  function start() { reveal(); wireRoute(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
